export const categories = [
  {
    slug: 'latest-address',
    name: '最新地址',
    description: 'JavBus 最新访问入口与可用域名汇总，确保您始终能够顺畅访问平台。',
    icon: 'ri-links-line',
  },
  {
    slug: 'search-tips',
    name: '搜索技巧',
    description: '掌握 JavBus 平台的高效搜索方法，通过番号、关键词精准定位影片内容。',
    icon: 'ri-search-line',
  },
  {
    slug: 'usage-tutorial',
    name: '使用教程',
    description: '从零开始学习 JavBus 平台各项功能，新手入门到高级用法的完整指南。',
    icon: 'ri-book-open-line',
  },
  {
    slug: 'mirror-sites',
    name: '镜像站点',
    description: 'JavBus 全球镜像站点列表，解决访问受限问题，畅享无障碍浏览体验。',
    icon: 'ri-global-line',
  },
  {
    slug: 'faq',
    name: '常见问题',
    description: 'JavBus 使用过程中最常见的问题汇总与详细解答，快速排除使用障碍。',
    icon: 'ri-question-answer-line',
  },
];